import Box from "@mui/material/Box";
import type { SxProps } from "@mui/material/styles";

type WordProcessorHtmlContentProps = {
  html?: string | null;
  sx?: SxProps;
  dataReport?: string;
  dataTest?: string;
  dataTestId?: string;
};
export default function WordProcessorHtmlContent({
  dataTest,
  dataTestId,
  dataReport,
  html = "",
  sx = {}
}: WordProcessorHtmlContentProps) {
  return (
    <Box
      className="tiny-cloud-html"
      data-testid={dataTestId}
      data-test={dataTest}
      data-report={dataReport}
      sx={{
        wordBreak: "break-word",
        pt: 2,
        width: "100%",
        boxSizing: "border-box",
        "& img": {
          maxWidth: "100%",
          height: "auto",
          objectFit: "contain"
        },
        ...sx
      }}
      dangerouslySetInnerHTML={{
        __html: html?.replace(/!--SUNO:(.*?)--/g, "{{$1}}") ?? ""
      }}
    />
  );
}
